<template>
  <v-layout row>
    <v-flex xs12 sm12>
        <v-card class="elavation-1 transparent">
            <v-toolbar class="transparent" flat height="37">    
                <v-btn dark icon title="Back" @click="$router.push(`/projects`)">
                    <v-icon>arrow_back</v-icon>
                </v-btn>            
                <v-spacer></v-spacer>
                <help-link appId="projects" pageId="creating-project" color="white"></help-link>
                <v-btn v-if="hasEditRights" dark color="primary" title="Create New Project" @click="showAddProject">
                    <v-icon dark>add</v-icon>&nbsp;Create Project&nbsp;&nbsp;
                </v-btn>
            </v-toolbar>
        </v-card>

        <!-- details -->
        <v-card class="elavation-1" style="margin-top:5px;"> 
            <v-toolbar flat height="45px">
                <div class="wp-30 mb-10">
                    <v-text-field v-model="search" append-icon="search" label="Search project code, name, description, client, status, task" single-line hide-details></v-text-field>
                </div>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-data-table
                :headers="headers"
                :items="projects_filtered"
                :loading="loading"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="paginationSync"
            >
                <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                <template v-slot:items="props">
                    <tr @click="viewDetails(props.item.projectId)" style="cursor:pointer;" title="Click to view project details">
                        <td>{{ props.item.projectCode }}</td>
                        <td>{{ props.item.projectName }}</td>
                        <td>{{ props.item.client }}</td>
                        <td>{{ props.item.projectDescription }}</td>
                        <td>
                            <v-chip v-if="props.item.createdByName" small style="margin-left:-5px;">
                                <v-avatar>
                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.createdBy)"></v-img>
                                </v-avatar>
                                {{props.item.createdByName}}
                            </v-chip>
                            <span v-else>System Generated</span>
                        </td>
                        <td>
                            <span v-if="props.item.projectKey=='Admin'"></span>
                            <span v-else>{{ props.item.createdOn | moment('MMM DD, YYYY') }}</span>
                        </td>
                        <td>
                            <span :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</span>
                        </td>
                    </tr>
                </template>
            </v-data-table> 
        </v-card>
    </v-flex>
    <v-dialog v-model="dialogProject" width="600" persistent>   
        <project ref="projectCompRef" @send="viewDetails" :dialogProject.sync="dialogProject"></project>
    </v-dialog>
  </v-layout>  
</template>

<script>
import projectsApi from '@/api/projects'
import commonfn from '@/common/functions'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {   
    name: 'Projects',
    metaInfo: {
        title: 'Projects',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Create Project' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },  
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'project': () => import('@/components/Projects/AddEditProject')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {   
            commonfn,    
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,    
            search: null,
            dialogProject: false,
            headers: [
                {text:'Project Code', align:'left', value:'projectCode', width:'10%', sortable:true},
                {text:'Project Name', align:'left', value:'projectName', width:'10%', sortable:true},
                {text:'Client', align:'left', value:'client', width:'10%', sortable:true},
                {text:'Description', align:'left', value:'description', width: '10%', sortable:true},
                {text:'Created By', align:'left', value:'createdOn', width:'5%', sortable:true},
                {text:'Created On', align:'left', value:'createdOn', width:'5%', sortable:true},
                {text:'Status', align:'left', value:'status', width:'5%', sortable:true},
            ],
            expand: false,
            projects: [],
        }
    },
    methods: { 
        viewDetails(projectId) {
            this.$router.push(`detail/${projectId}`)
        },
        showAddProject() {
            this.$refs.projectCompRef.setProjectAdd(this.projects)
            this.dialogProject = true
        },   
        async getProjects() {
            try{
                this.loading = true
                const response = await projectsApi.get(true)
                if (response && response.status == 200) {                    
                    this.projects = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Manage Projects'
        })

        this.getProjects()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        projects_filtered() {
            if (this.search) {
                var temp = this.projects.filter(item => {
                    return (
                        item.projectKey.toLowerCase().includes(this.search.toLowerCase())
                        || item.projectName.toLowerCase().includes(this.search.toLowerCase())
                        || item.projectDescription.toLowerCase().includes(this.search.toLowerCase())
                        || item.projectCode.toLowerCase().includes(this.search.toLowerCase())
                        || item.client.toLowerCase().includes(this.search.toLowerCase())
                        || commonfn.getStatusDescription(item.status).toLowerCase().includes(this.search.toLowerCase())
                        //nested search
                        || item.projectTasks.filter(t => {
                            return t.taskName.toLowerCase().includes(this.search.toLowerCase())
                                    || t.taskDescription.toLowerCase().includes(this.search.toLowerCase())
                                    || t.taskCode.toLowerCase().includes(this.search.toLowerCase())
                                    || t.projectTaskKey.toLowerCase().includes(this.search.toLowerCase())
                        }).length 
                    )
                }) 
                return temp
            }
            return this.projects
        }
    }
}
</script>